import React, {useContext, useEffect, useState} from "react";
import {Alert, Box, Grid} from '@deere/fuel-react';
import {OVERRIDDEN_SCORE} from "../shared/Constants";
import {ReasonsContext} from './Ratings';
import { Typography } from "@mui/material";

export const OverrideScoreView = ({criteria}) => {
    const [reason, setReason] = useState("");
    const reasons = useContext(ReasonsContext);

    useEffect(() => {
        if (criteria.overridePoints || criteria.overrideReason) {
            const reason = reasons.filter(item => item.id === criteria.overrideReason.reasonId).map(reason => reason.reason)
            setReason(reason)
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Grid item xs={12}>
        <Box pl={8} pt={2} pb={2}>
            <Alert variant={"info"}>
                <Typography fontWeight="bold" size="md" component="span">
                    {OVERRIDDEN_SCORE} : {reason}
                </Typography>
                <br/>
                <Typography size="sm" component="span">
                    {criteria.overrideReason && criteria.overrideReason.updatedBy} | {criteria.overrideReason && criteria.overrideReason.comments}
                </Typography>
            </Alert>
        </Box>
    </Grid>;
}